import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // catch the select2 jQuery event and dispatch a native event
    // so we can treat regular <select> and select2 dropdowns the same
    $(this.element).on("select2:unselect", (event) => {
      this.triggerChangeEvent(event);
    });

    $(this.element).on("select2:select", (event) => {
      this.triggerChangeEvent(event);
    });
  }

  triggerChangeEvent(event) {
    const changeEvent = new Event("change", { bubbles: true });
    event.target.dispatchEvent(changeEvent);
  }
}
